import styled, { css } from 'styled-components';
import { Box, BoxProps } from '@bechtel/gds';
import { Scalars } from '@bechtel/types';

type BlockStyledProps = BoxProps & {
  selected: Scalars['Boolean'];
};

const getBlockBackground = (props: BlockStyledProps) =>
  props.selected &&
  css`
    background-color: ${({ theme }) => theme.colors.bechtel.blue[100]};
    &:hover {
      background-color: ${({ theme }) => theme.colors.bechtel.blue[100]};
    }
  `;

export const BlockStyled = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  p: { sm: '500' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grey[100]};
  }
  ${getBlockBackground}
`;


